module.exports = __webpack_public_path__ + "img/garage.375bcbfd.png";